import { axiosInstance } from "../../utility/apiInstance";
import { Organisation } from "./communicationError.types";

export const fetchOrganisations = async (): Promise<Organisation[]> => {
  const { data } = await axiosInstance("/api/v1/organisation");
  const raw = data?.data?.data ?? data?.data ?? [];
  return raw
    .filter((ele: any) => ele.isActive === true)
    .map((ele: any) => ({ _id: ele._id, name: ele.organizationName }));
};

export const fetchCommunicationErrors = async (
  orgId: string,
  page: number,
  limit: number,
  search: string
) => {
  const searchParam = search.trim()
    ? `&search=${encodeURIComponent(search.trim())}`
    : "";
  const { data } = await axiosInstance(
    `/api/v1/communication-errors/${orgId}?page=${page}&limit=${limit}${searchParam}`
  );
  return data.data; // { data: CommunicationError[], pagination: Pagination }
};